import React, { PropTypes } from 'react';
import s from './Collapse.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const transitionName={
  enter: s.enter,
  enterActive: s.enterActive,
  leave: s.leave,
  leaveActive: s.leaveActive,
  appear: s.appear,
  appearActive: s.appearActive
};

class CollapseContainer extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
  };

  render() {
    let { open, children } = this.props;

    return (
      <ReactCSSTransitionGroup transitionName={transitionName}
                               transitionAppear={true}
                               transitionAppearTimeout={500}
                               transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                               {open ? children : null}
      </ReactCSSTransitionGroup>
    );
  }
}

export default CollapseContainer;



// WEBPACK FOOTER //
// ./src/components/Collapse/CollapseContainer.js